import type { LogEntry } from '../types/game';

export function makeEntry(text: string, type: LogEntry['type'] = 'info'): LogEntry {
  return { text, type, timestamp: Date.now() };
}

export function fmtCoins(n: number): string {
  return n.toFixed(2);
}

export function spacer(): LogEntry {
  return makeEntry('', 'info');
}
